import React, { useState, useEffect } from 'react';
import FetchApi from '../../../../customhooks/functionFetchApi';

const ViewCoatingsystem = (props) => {
    const FetchApis = new FetchApi();
    const [coatingBody, setCoatingBody] = useState(null);
    const [coatingTop, setCoatingTop] = useState(null);
    const [coatingBottom, setCoatingBottom] = useState(null);

    useEffect(() => {
        fetchCoatingData();
    }, []);

    const fetchCoatingData = async () => {
        try {
            await FetchApis.FethcGet(`/coating/coatingByJournalId/${props.jourId}`)
                .then((response) => {
                    const data = response.data.data || [];
                    data.forEach((item) => {
                        if (item.producttype === 'body') setCoatingBody(item);
                        else if (item.producttype === 'top') setCoatingTop(item);
                        else if (item.producttype === 'bottom') setCoatingBottom(item);
                    });
                });
        } catch (error) {
            console.error('Error fetching coating data:', error);
        }
    };

    const tdStyle = { padding: '4px 8px', border: '1px solid #ccc' };
    const thStyle = { padding: '4px 8px', border: '1px solid #ccc', backgroundColor: '#f0f0f0', textAlign: 'center' };

    return (
        <div>
            <b>Coating System</b>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 6 }}>
                <thead>
                    <tr>
                        <th style={thStyle}>Side</th>
                        <th style={thStyle}>body</th>
                        <th style={thStyle}>White Coat body</th>
                        <th style={thStyle}>Top</th>
                        <th style={thStyle}>White Coat top</th>
                        <th style={thStyle}>Bottom</th>
                        <th style={thStyle}>White Coat bottom</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 'bold' }}>Product Shape</td>
                        <td style={tdStyle} colSpan={2}>{coatingBody?.groupBobyType || '-'}</td>
                        <td style={tdStyle} colSpan={2}>{coatingTop?.groupBobyType || '-'}</td>
                        <td style={tdStyle} colSpan={2}>{coatingBottom?.groupBobyType || '-'}</td>
                    </tr>
                    <tr>
                        <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 'bold' }}>Int.</td>
                        <td style={tdStyle}>{coatingBody?.intcoating || '-'}</td>
                        <td style={tdStyle}>{coatingBody?.intwhite || '-'}</td>
                        <td style={tdStyle}>{coatingTop?.intcoating || '-'}</td>
                        <td style={tdStyle}>{coatingTop?.intwhite || '-'}</td>
                        <td style={tdStyle}>{coatingBottom?.intcoating || '-'}</td>
                        <td style={tdStyle}>{coatingBottom?.intwhite || '-'}</td>
                    </tr>
                    <tr>
                        <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 'bold' }}>Ext.</td>
                        <td style={tdStyle}>{coatingBody?.extcoating || '-'}</td>
                        <td style={tdStyle}>
                            {coatingBody?.exttypewhite && <span style={{ marginRight: 6 }}>{coatingBody.exttypewhite}</span>}
                            {coatingBody?.extwhite || ''}
                            {!coatingBody?.exttypewhite && !coatingBody?.extwhite && '-'}
                        </td>
                        <td style={tdStyle}>{coatingTop?.extcoating || '-'}</td>
                        <td style={tdStyle}>
                            {coatingTop?.exttypewhite && <span style={{ marginRight: 6 }}>{coatingTop.exttypewhite}</span>}
                            {coatingTop?.extwhite || ''}
                            {!coatingTop?.exttypewhite && !coatingTop?.extwhite && '-'}
                        </td>
                        <td style={tdStyle}>{coatingBottom?.extcoating || '-'}</td>
                        <td style={tdStyle}>
                            {coatingBottom?.exttypewhite && <span style={{ marginRight: 6 }}>{coatingBottom.exttypewhite}</span>}
                            {coatingBottom?.extwhite || ''}
                            {!coatingBottom?.exttypewhite && !coatingBottom?.extwhite && '-'}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default ViewCoatingsystem;
